import { ACTION } from './constants';

type ProductsObject = {
    productId: string | undefined;
    itemPrice: string | undefined;
    qty: string;
    sku: string;
};

class AnalyticsHelper {
    async dispatchAdobeAnalytics(
        action: ACTION,
        location?: string,
        description?: string,
        type?: string,
        subType?: string,
        additionalInfo?: Record<string, string>,
        products?: ProductsObject,
    ): Promise<void> {
        const detailObject = {
            action,
            ...(location && { location }),
            ...(description && { description }),
            ...(type && { type }),
            ...(subType && { subType }),
            ...(additionalInfo && { additionalInfo }),
            ...(products && { products }),
        };

        document.body.dispatchEvent(
            new CustomEvent('dataStateChange', {
                detail: { ...detailObject },
            }),
        );
    }

    async setProductIdOnJLData(productId: string): Promise<void> {
        if (!window.jlData) {
            window.jlData = {
                page: {
                    productPages: {
                        productId: productId,
                    },
                },
            };
        } else {
            if (!window.jlData.page?.productPages?.productId) {
                window.jlData = Object.assign(window.jlData, {
                    page: {
                        productPages: {
                            productId: productId,
                        },
                    },
                }) as JLData;
            }
        }
    }
}

export * from './constants';

export const Analytics = new AnalyticsHelper();

export default Analytics;
